import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40f18dfb")

_pushScopeId("data-v-40f18dfb")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 設定 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("戻る ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("登録 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("設定を変更しますか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_calendar_start_day = _resolveComponent("calendar-start-day")
  const _component_appointment = _resolveComponent("appointment")
  const _component_holiday_auto_close = _resolveComponent("holiday-auto-close")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          _createVNode(_component_calendar_start_day),
          _createVNode(_component_appointment),
          _createVNode(_component_holiday_auto_close)
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "normal",
            onClick: _ctx.back
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        right: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "warning",
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})